// Mixed content types representing a variety of real-world scenarios
export default [
    // News article with breaking news style
    {
        id: '1',
        type: 'article',
        title: '🔴 BREAKING: Earthquake Strikes Pacific Region',
        pretitle: 'URGENT',
        author: 'Reuters News Agency',
        by_line: 'Breaking News Desk',
        body: '<div><p><strong>TOKYO</strong> - A magnitude 7.2 earthquake struck off the coast of Japan at 14:32 local time. Tsunami warnings have been issued for coastal areas.</p><p>Authorities are urging immediate evacuation from low-lying areas. No casualties have been reported yet.</p></div>',
        image_url: 'https://images.unsplash.com/photo-1547683905-f686c993aae5?w=800&q=80',
        image_caption: 'Seismic activity monitoring station',
        start_page: 1,
        end_page: 1,
        location_in_start_page: { x: '10.5', y: '5.2' },
        content_metrics: {
            total_number_of_words: 85,
            reading_time_minutes: 1,
        },
    },

    // Long-form investigative journalism
    {
        id: '2',
        type: 'article',
        title: 'The Hidden Cost of Fast Fashion: A Global Investigation',
        pretitle: 'INVESTIGATION',
        author: 'Jennifer Martinez & David Chen',
        by_line: 'Investigative Journalists',
        body: `<div>
            <p class="lead">After six months of investigation across three continents, our team uncovered the true environmental and human cost of the fast fashion industry.</p>
            
            <h2>The Numbers Don't Lie</h2>
            <p>The fashion industry produces 10% of global carbon emissions and is the second-largest consumer of water worldwide. Our investigation found:</p>
            <ul>
                <li>92 million tons of textile waste created annually</li>
                <li>500,000 tons of microfibers released into oceans each year</li>
                <li>20% of global water pollution comes from textile treatment</li>
            </ul>
            
            <h2>Human Impact</h2>
            <p>Workers in Bangladesh, Vietnam, and Cambodia face dangerous conditions for wages as low as $68 per month. We interviewed 147 workers who reported:</p>
            <blockquote>"We work 14-hour days, six days a week. The factory has no proper ventilation, and many of us develop respiratory problems." - Anonymous worker, Dhaka</blockquote>
            
            <h2>The Path Forward</h2>
            <p>Sustainable alternatives exist, but require systemic change in consumer behavior and corporate responsibility.</p>
        </div>`,
        image_url: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&q=80',
        image_caption: 'Textile factory workers in Southeast Asia',
        start_page: 2,
        end_page: 5,
        location_in_start_page: { x: '15.0', y: '10.0' },
        location_in_end_page: { x: '85.0', y: '90.0' },
        content_metrics: {
            total_number_of_words: 1250,
            reading_time_minutes: 5,
        },
    },

    // Interactive infographic
    {
        id: '3',
        type: 'image',
        title: 'Climate Change: By The Numbers',
        image_url: 'https://images.unsplash.com/photo-1611273426858-450d8e3c9fce?w=1200&q=80',
        image_caption: 'Interactive climate data visualization - tap to explore',
        image_name: 'climate_infographic.jpg',
        start_page: 6,
        end_page: 6,
        location_in_start_page: { x: '20.0', y: '15.0' },
        interactive: true,
        data_points: [
            { label: 'CO2 Levels', value: '421 ppm', trend: 'rising' },
            { label: 'Global Temp', value: '+1.2°C', trend: 'rising' },
            { label: 'Ice Loss', value: '427 Gt/year', trend: 'accelerating' },
        ],
    },

    // Video content
    {
        id: '4',
        type: 'video',
        title: 'Documentary: Life in the Deep Ocean',
        pretitle: 'EXCLUSIVE PREMIERE',
        description: 'Explore the mysteries of the Mariana Trench with cutting-edge submarine technology',
        video_url: 'https://example.com/deep-ocean-doc.mp4',
        thumbnail_url: 'https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=800&q=80',
        duration: '52:30',
        director: 'Maria Thompson',
        year: 2024,
        start_page: 7,
        end_page: 7,
        location_in_start_page: { x: '25.0', y: '20.0' },
    },

    // Podcast/Audio content
    {
        id: '5',
        type: 'audio',
        title: 'Tech Talk: The AI Revolution',
        pretitle: 'PODCAST EPISODE 127',
        description: 'Leading experts discuss the implications of artificial general intelligence',
        audio_url: 'https://example.com/tech-talk-127.mp3',
        duration: '38:45',
        host: 'Dr. Alan Roberts',
        guests: ['Sam Altman', 'Yoshua Bengio', 'Timnit Gebru'],
        start_page: 8,
        end_page: 8,
        location_in_start_page: { x: '50.0', y: '30.0' },
        transcript_available: true,
    },

    // Recipe/How-to content
    {
        id: '6',
        type: 'article',
        title: 'Master Chef Recipe: Perfect Sourdough Bread',
        pretitle: 'COOKING',
        author: 'Chef Gordon Ramsay',
        body: `<div>
            <div class="recipe-meta">
                <span>⏱ Prep: 30 min</span> | <span>🔥 Cook: 45 min</span> | <span>⏳ Total: 24 hours</span>
            </div>
            
            <h3>Ingredients</h3>
            <ul class="ingredients">
                <li>500g bread flour</li>
                <li>375g water (75% hydration)</li>
                <li>100g active sourdough starter</li>
                <li>10g salt</li>
            </ul>
            
            <h3>Instructions</h3>
            <ol class="steps">
                <li>Mix flour and water, autolyse for 1 hour</li>
                <li>Add starter and salt, mix thoroughly</li>
                <li>Bulk ferment for 4-6 hours with folds every 30 minutes</li>
                <li>Shape and proof overnight in refrigerator</li>
                <li>Bake at 475°F in Dutch oven</li>
            </ol>
        </div>`,
        image_url: 'https://images.unsplash.com/photo-1509440159596-0249088772ff?w=800&q=80',
        image_caption: 'Freshly baked sourdough bread',
        start_page: 9,
        end_page: 10,
        location_in_start_page: { x: '30.0', y: '25.0' },
        location_in_end_page: { x: '70.0', y: '75.0' },
    },

    // Sports statistics
    {
        id: '7',
        type: 'article',
        title: 'Championship Finals: Complete Statistics',
        pretitle: 'SPORTS',
        author: 'ESPN Analytics',
        body: `<div>
            <table class="stats-table">
                <thead>
                    <tr>
                        <th>Player</th>
                        <th>Points</th>
                        <th>Rebounds</th>
                        <th>Assists</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>LeBron James</td>
                        <td>28.5</td>
                        <td>10.2</td>
                        <td>7.8</td>
                    </tr>
                    <tr>
                        <td>Kevin Durant</td>
                        <td>31.2</td>
                        <td>7.5</td>
                        <td>5.2</td>
                    </tr>
                </tbody>
            </table>
        </div>`,
        start_page: 11,
        end_page: 11,
        location_in_start_page: { x: '45.0', y: '40.0' },
    },

    // Photo gallery
    {
        id: '8',
        type: 'gallery',
        title: 'Year in Pictures: 2024',
        pretitle: 'PHOTOGRAPHY',
        images: [
            {
                url: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&q=80',
                caption: 'Swiss Alps at sunrise',
                photographer: 'Anna Chen',
            },
            {
                url: 'https://images.unsplash.com/photo-1501594907352-04cda38ebc29?w=800&q=80',
                caption: 'Golden Gate Bridge in fog',
                photographer: 'Mike Johnson',
            },
            {
                url: 'https://images.unsplash.com/photo-1505142468610-359e7d316be0?w=800&q=80',
                caption: 'Santorini sunset',
                photographer: 'Elena Rodriguez',
            },
        ],
        start_page: 12,
        end_page: 14,
        location_in_start_page: { x: '10.0', y: '10.0' },
        location_in_end_page: { x: '90.0', y: '90.0' },
    },

    // Advertisement
    {
        id: '9',
        type: 'advertisement',
        title: 'Premium Watch Collection 2024',
        advertiser: 'Luxury Timepieces Inc.',
        campaign_id: 'WT2024Q4',
        cta_text: 'Discover More',
        cta_url: 'https://example.com/watches',
        start_page: 15,
        end_page: 15,
        location_in_start_page: { x: '0.0', y: '0.0' },
        full_page: true,
    },

    // Book review
    {
        id: '10',
        type: 'article',
        title: 'Review: "The Midnight Library" by Matt Haig',
        pretitle: 'BOOK REVIEW',
        author: 'Literary Critic Sarah Jones',
        body: `<div>
            <div class="rating">⭐⭐⭐⭐½</div>
            <p class="synopsis"><em>Between life and death there is a library, and within that library, the shelves go on forever...</em></p>
            <p>Matt Haig's "The Midnight Library" is a profound meditation on regret, choice, and the infinite possibilities of life. The novel follows Nora Seed as she navigates parallel lives she could have lived.</p>
            <p><strong>Verdict:</strong> A thought-provoking and ultimately uplifting exploration of what it means to live.</p>
        </div>`,
        image_url: 'https://images.unsplash.com/photo-1544947950-fa07a98d237f?w=400&q=80',
        image_caption: 'Book cover',
        start_page: 16,
        end_page: 16,
        location_in_start_page: { x: '55.0', y: '15.0' },
        metadata: {
            isbn: '978-0525559474',
            publisher: 'Viking',
            publication_date: '2020-08-13',
            pages: 288,
        },
    },

    // Scientific paper abstract
    {
        id: '11',
        type: 'article',
        title: 'Quantum Entanglement in Room Temperature Semiconductors',
        pretitle: 'RESEARCH PAPER',
        author: 'Dr. Liu Wei et al.',
        by_line: 'Nature Physics, Vol. 20, 2024',
        body: `<div class="abstract">
            <h3>Abstract</h3>
            <p>We report the observation of quantum entanglement in semiconductor quantum dots at room temperature. Using advanced spectroscopy techniques, we demonstrate sustained entanglement for up to 100 nanoseconds, three orders of magnitude longer than previous reports.</p>
            <p><strong>Keywords:</strong> quantum entanglement, semiconductors, quantum computing, room temperature</p>
            <p><strong>DOI:</strong> 10.1038/s41567-024-02345-1</p>
        </div>`,
        start_page: 17,
        end_page: 17,
        location_in_start_page: { x: '12.0', y: '60.0' },
    },

    // Social media embed
    {
        id: '12',
        type: 'social_embed',
        title: 'Viral Tweet of the Day',
        platform: 'twitter',
        embed_id: '1234567890',
        author_handle: '@techguru',
        author_name: 'Tech Guru',
        content:
            'Just launched our new app and crashed our servers with 1M downloads in the first hour! 🚀 Thank you all for the amazing support! #startup #success',
        likes: 45200,
        retweets: 8900,
        timestamp: '2024-01-15T14:30:00Z',
        start_page: 18,
        end_page: 18,
        location_in_start_page: { x: '35.0', y: '45.0' },
    },

    // Comic strip
    {
        id: '13',
        type: 'comic',
        title: 'Daily Comic: Office Life',
        author: 'Jim Davis',
        panels: [
            { url: 'https://example.com/comic-panel-1.jpg' },
            { url: 'https://example.com/comic-panel-2.jpg' },
            { url: 'https://example.com/comic-panel-3.jpg' },
        ],
        start_page: 19,
        end_page: 19,
        location_in_start_page: { x: '20.0', y: '70.0' },
    },

    // Weather widget
    {
        id: '14',
        type: 'widget',
        widget_type: 'weather',
        title: "Today's Weather",
        data: {
            location: 'New York, NY',
            temperature: '72°F',
            condition: 'Partly Cloudy',
            high: '78°F',
            low: '65°F',
            precipitation: '20%',
        },
        start_page: 20,
        end_page: 20,
        location_in_start_page: { x: '75.0', y: '10.0' },
    },

    // Stock market data
    {
        id: '15',
        type: 'financial',
        title: 'Market Update',
        pretitle: 'FINANCE',
        body: `<div class="market-data">
            <div class="index">
                <span class="name">S&P 500</span>
                <span class="value">4,783.45</span>
                <span class="change positive">+1.2%</span>
            </div>
            <div class="index">
                <span class="name">NASDAQ</span>
                <span class="value">15,123.67</span>
                <span class="change positive">+1.8%</span>
            </div>
            <div class="index">
                <span class="name">DOW</span>
                <span class="value">38,456.12</span>
                <span class="change negative">-0.3%</span>
            </div>
        </div>`,
        start_page: 20,
        end_page: 20,
        location_in_start_page: { x: '75.0', y: '50.0' },
        update_frequency: 'real-time',
    },
];
